import { useEffect, useState } from "react";
import { getUsers } from "../../services/firebase";
import { Link } from "react-router-dom";
import firebase from "firebase";
import { toast } from "sonner";

type User = {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  bio: string;
  phone: string;
  addresses: string[];
  memberships: string[];
  user_types: string[];
  note: string;
};

export const Users = (props: any) => {
  const [users, setUsers] = useState<User[]>();

  useEffect(() => {
    async function getStuff() {
      const u = (await getUsers()) as User[];
      setUsers(u);
    }
    getStuff();
  }, []);

  function sendResetPasswordEmail(email: string) {
    return firebase
      .auth()
      .sendPasswordResetEmail(email)
      .then(() => {
        toast.success("email sent", { duration: 5000 });
      })
      .catch((e) => {
        console.log(e);
        toast.error(e.message, { duration: 5000 });
      });
  }

  function removeUser(id: string) {
    return firebase
      .firestore()
      .collection("users")
      .doc(id)
      .delete()
      .then((res) => {
        toast.success(`removed`, { duration: 5000 });
      })
      .catch((e) => {
        toast.error(e.message, { duration: 5000 });
      });
  }

  if (!users) {
    return <></>;
  }

  return (
    <div className="m-8">
      <div className="flex justify-between border-b">
        <div className="p-2">Users</div>
        <div className="p-2">
          <Link to="/create-user">Add New</Link>
        </div>
      </div>
      <table className="table-auto w-full border-collapse border border-emerald-800">
        <thead>
          <tr>
            <th className="border border-emerald-600">id</th>
            <th className="border border-emerald-600">email</th>
            <th className="border border-emerald-600">first name</th>
            <th className="border border-emerald-600">last name</th>
            <th className="border border-emerald-600">user types</th>
            <th className="border border-emerald-600"></th>
            <th className="border border-emerald-600"></th>
          </tr>
        </thead>
        <tbody>
          {users.map((user, index) => {
            return (
              <tr key={index} className="p-2 m-2">
                <td className="px-4 border border-emerald-600">{user.id}</td>
                <td className="px-4 border border-emerald-600">{user.email}</td>
                <td className="px-4 border border-emerald-600">
                  {user.first_name}
                </td>
                <td className="px-4 border border-emerald-600">
                  {user.last_name}
                </td>
                <td className="px-4 border border-emerald-600">
                  {user.user_types &&
                    user.user_types.map((type, index) => {
                      return <div key={index}>{type}</div>;
                    })}
                </td>
                <td className="px-4 border border-emerald-600">
                  <button
                    className="underline"
                    onClick={() => sendResetPasswordEmail(user.email)}
                  >
                    reset password
                  </button>
                </td>
                <td className="px-4 border border-emerald-600">
                  <button
                    className="underline"
                    onClick={() => removeUser(user.id)}
                  >
                    remove
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
